import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=8ba0de4c"
import script from "./Sent.vue?vue&type=script&lang=js"
export * from "./Sent.vue?vue&type=script&lang=js"
import style0 from "./Sent.vue?vue&type=style&index=0&id=8ba0de4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports